import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { BoxGroupInfos } from 'src/app/models/box-group-infos';
import { BoxInfos } from 'src/app/models/box-infos';
import { ViewType } from 'src/app/models/server/enums/view-type';
import { View } from 'src/app/models/server/view';
import { SpinnerService } from 'src/app/services/core/spinner.service';
import { FoldersService } from 'src/app/services/http/folders.service';
import { UsersService } from 'src/app/services/http/users.service';
import { BoxesStateService } from 'src/app/services/state/boxes-state.service';
import { ViewsStateService } from 'src/app/services/state/views-state.service';
import { BoxesGroupComponent } from './boxes-group/boxes-group.component';
import { BoxesSummaryComponent } from './boxes-summary/boxes-summary.component';

@Component({
    selector: 'app-folders-list-boxes-selector',
    templateUrl: './folders-list-boxes-selector.component.html',
    styleUrls: ['./folders-list-boxes-selector.component.scss'],
    imports: [BoxesGroupComponent, BoxesSummaryComponent, NgxSpinnerModule]
})
export class FoldersListBoxesSelectorComponent implements OnInit, OnDestroy {
    /**
     * Utilisé pour gérer la désincription des observables lorsque le composant est détruit.
     */
    protected componentDestroyed$: Subject<void> = new Subject<void>();

    public datasource: BoxGroupInfos[] = null;
    public boxIds: string[] = [];

    public faLoad = faSpinner;

    /**
     * Valeur indiquant si les composants enfants doivent émettre des événements. False : n'émetent pas d'événement.
     */
    public quietChildren: boolean;

    private view$ = new BehaviorSubject<View>(null);

    public _internalView: View;

    @Input()
    set view(value) {
        this.view$.next(value);
    }

    get view() {
        return this.view$.getValue();
    }

    constructor(
        private usersService: UsersService,
        private foldersService: FoldersService,
        private boxesStateService: BoxesStateService,
        private viewsStateService: ViewsStateService,
        private spinner: SpinnerService
    ) {}

    ngOnInit(): void {
        this.subscribeToViewSelectionChangeEvent();
    }

    /**
     * Appelée à la destruction du composant.
     */
    ngOnDestroy(): void {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }

    /**
     * S'abonne aux événements de changement de vue sélectionnée.
     */
    private subscribeToViewSelectionChangeEvent() {
        this.view$.pipe(takeUntil(this.componentDestroyed$)).subscribe((x: View) => {
            if (!!x) {
                if (x.viewType === ViewType.Box || x.viewType === ViewType.ArchivingBox) {
                    this.spinner.show('boxes-spinner');
                    this.quietChildren = true;
                    this.usersService
                        .getViewBoxGroups(x.id)
                        .pipe(takeUntil(this.componentDestroyed$))
                        .subscribe((bg) => {
                            this.datasource = bg.map<BoxGroupInfos>((v) => new BoxGroupInfos(v));
                            this.boxesStateService.setBoxesGroupsList(this.datasource);

                            this.usersService
                                .GetCurrentUserDefaultBoxSelection(x.id)
                                .pipe(takeUntil(this.componentDestroyed$))
                                .subscribe((dbs) => {
                                    let selectedBoxes: BoxInfos[] = [];

                                    this.datasource.forEach((bg) => {
                                        // Mise à jour de la selection par défaut des bannettes.
                                        bg.boxes.forEach((b) => {
                                            if (dbs.indexOf(b.id) != -1) {
                                                b.selected = true;
                                                selectedBoxes.push(b);
                                            }
                                        });

                                        bg.boxes.forEach((b) => {
                                            // Mise à jour des compteurs de bannettes.
                                            this.foldersService.folderBoxCount(b.id).subscribe((c) => {
                                                b.count = c;
                                                this.boxesStateService.updateBoxCount(b);
                                            });
                                        });
                                    });
                                    this.boxesStateService.updateBoxesSelectionState(selectedBoxes);
                                    this.quietChildren = false;
                                    this.spinner.hide('boxes-spinner');
                                });
                        });
                }
            }
        });
    }
}
